import client from "../api/client";

export const getList = () => {
  return client('/api/membership-shares').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/membership-shares/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/membership-shares/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/membership-shares', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/membership-shares/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useMembershipShareService () {
  return {
    getList,
    addEditModel,
    getDetail,
    delModel
  };
}
